


import React, { useState, useEffect } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // ✅ Improved UX
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const navigate = useNavigate();

  // useEffect(() => {
  //   // 1. AUTO REDIRECT IF ALREADY LOGGED IN
  //   if (localStorage.getItem("admin_id")) {
  //     navigate("/dashboard");
  //   }




  useEffect(() => {
    if (localStorage.getItem("admin_id")) {

      const userType = localStorage.getItem("user_type");

      if (userType === "accounts") {
        navigate("/download-excel-for-accounts");
      } else {
        navigate("/dashboard");
      }
    }






    // 2. Initialize Particles Background (matching Landing Page)
    const initParticles = () => {
      if (window.particlesJS) {
        window.particlesJS("particles-js-login", {
          particles: {
            number: { value: 60, density: { enable: true, value_area: 800 } },
            color: { value: "#ffffff" },
            opacity: { value: 0.1, random: true },
            size: { value: 1.5, random: true },
            line_linked: { enable: true, distance: 150, color: "#ffffff", opacity: 0.08, width: 1 },
            move: { enable: true, speed: 0.5, direction: "none", random: true, out_mode: "out" }
          },
          interactivity: {
            events: { onhover: { enable: true, mode: "grab" } },
            modes: { grab: { distance: 180, line_linked: { opacity: 0.3 } } }
          }
        });
      }
    };

    if (window.particlesJS) {
      initParticles();
    } else {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/particles.js";
      script.async = true;
      script.onload = initParticles;
      document.body.appendChild(script);
    }

    // 3. Mouse Spotlight Tracking
    const handleMouseMove = (e) => {
      setMousePos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [navigate]);

  const handleLogin = async () => {
    // ✅ BASIC VALIDATION
    if (!email || !password) {
      alert("⚠ Please enter both email and password.");
      return;
    }

    try {
      setLoading(true); // ✅ START LOADING

      const res = await API.post(
        "/admin/login",
        { email, password },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("SUCCESS:", res.data);

      // ✅ STORE LOGIN STATE
      localStorage.setItem("admin_id", res.data.admin_id || "true");
      localStorage.setItem("user_type", res.data.user_type);


      // ✅ STORE ROLE
      if (res.data.role) {
        localStorage.setItem("role", res.data.role);
      }

      // ✅ FORCE NAVIGATION
      if (res.data.user_type === "accounts") {
  navigate("/download-excel-for-accounts", { replace: true });
} else {
  navigate("/dashboard", { replace: true });
}

    } catch (err) {
      console.log("ERROR DATA:", err.response?.data);
      alert(err.response?.data?.detail || "❌ Login failed. Check your credentials.");
    } finally {
      setLoading(false); // ✅ STOP LOADING
    }
  };

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap" rel="stylesheet" />

      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; font-family: 'Plus Jakarta Sans', sans-serif; }
        
        body { 
          min-height: 100vh; 
          color: white; 
          overflow: hidden; 
          background: #010410; /* Slightly darker than landing page */
        }

        /* Particles Layer */
        #particles-js-login {
          position: fixed;
          width: 100%; height: 100%;
          background: #010410;
          z-index: -1;
        }

        /* Spotlight Effect */
        .spotlight {
          position: fixed;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at ${mousePos.x}px ${mousePos.y}px, rgba(59, 130, 246, 0.25) 0%, transparent 45%);
          z-index: -1;
          pointer-events: none;
        }

        /* Container */
        .login-page-container {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          padding: 20px;
        }

        /* Glassmorphism Card */
        .login-card {
          width: 95%;
          max-width: 440px;
          padding: 3rem 2.5rem;
          border-radius: 36px;
          background: rgba(255, 255, 255, 0.02);
          backdrop-filter: blur(40px);
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 40px 100px -15px rgba(0, 0, 0, 0.7);
          animation: cardZoomIn 0.6s ease-out;
          text-align: center;
        }

        @keyframes cardZoomIn { from { opacity: 0; transform: scale(0.96); } to { opacity: 1; transform: scale(1); } }

        /* BRANDING AREA */
        .brand-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 2.5rem;
        }

        /* CSS-Animated VGM Logo (matched to landing) */
        .vgm-logo-css {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 3px;
          margin-bottom: 12px;
        }

        .block {
          width: 18px; height: 18px;
          position: relative;
          clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
          animation: blockColorFlip 8s ease-in-out infinite;
        }
        // .red { background: linear-gradient(135deg, #ef4444, #b91c1c); animation-delay: 0s; }
        // .orange { background: linear-gradient(135deg, #f59e0b, #d97706); animation-delay: 2s; }

        @keyframes blockColorFlip {
          0%, 100% { filter: contrast(1); }
          50% { filter: contrast(1.5) brightness(1.2); }
        }

        .vgm-title-text {
          font-size: 30px;
          font-weight: 800;
          color: #f1f5f9;
          letter-spacing: -1px;
        }

        .login-card h2 { font-size: 20px; color: #fbbf24; margin-bottom: 2rem; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px;}

        /* FORM INPUTS */
        .form-input-container {
          position: relative;
          width: 100%;
          margin-bottom: 1.2rem;
        }

        .form-input {
          width: 100%;
          padding: 16px 18px;
          border-radius: 14px;
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #f1f5f9;
          font-size: 15px;
          transition: all 0.3s ease;
        }

        .form-input::placeholder { color: #64748b; font-weight: 500; }
        .form-input:focus {
          outline: none;
          background: rgba(255, 255, 255, 0.06);
          border-color: #3b82f6; /* Blue border on focus */
          box-shadow: 0 0 15px rgba(59, 130, 246, 0.3);
        }

        /* Password Show/Hide Toggle */
        .password-toggle {
          position: absolute;
          right: 18px; top: 50%;
          transform: translateY(-50%);
          background: none; border: none;
          color: #64748b; font-size: 12px; font-weight: 700;
          cursor: pointer;
          opacity: 0.7;
          transition: opacity 0.3s ease;
        }
        .password-toggle:hover { opacity: 1; color: #f1f5f9; }

        /* ACTION BUTTON */
        .login-btn {
          width: 100%;
          padding: 16px;
          margin-top: 1rem;
          border-radius: 14px;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: none;
          position: relative;
          overflow: hidden;
          background: #3b82f6; /* Premium Blue */
          color: #fff;
          box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
        }

        .login-btn:not(:disabled):hover {
          background: #2563eb;
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.5);
        }

        .login-btn:disabled {
          background: #475569; /* Slate Gray when loading */
          cursor: not-allowed;
          box-shadow: none;
        }

        /* Loading Spinner */
        .spinner {
          display: inline-block;
          width: 14px; height: 14px;
          border: 2px solid rgba(255,255,255,0.3);
          border-radius: 50%;
          border-top-color: #fff;
          animation: spin 0.8s linear infinite;
          margin-right: 10px;
        }

        @keyframes spin { to { transform: rotate(360deg); } }

        .form-footer {
          margin-top: 1.8rem;
          font-size: 11px;
          color: #475569;
          letter-spacing: 1px;
        }

      `}</style>

      {/* Dynamic Background Effects */}
      <div id="particles-js-login"></div>
      <div className="spotlight"></div>

      <div className="login-page-container">
        <div className="login-card">

          {/* Custom Animated VGM Branding */}
          <div className="brand-header">
            <div className="vgm-logo-css">
              <div className="block red"></div>
              <div className="block orange"></div>
              <div className="block orange"></div>
              <div className="block red"></div>
            </div>
            <div className="brand-logo-container">
              <img
                src="/image.png"
                alt="VGM Logo"
                style={{
                  height: '70px',
                  width: 'auto',
                  objectFit: 'contain',
                  // filter: 'brightness(1) invert(2)' 
                }}
              />
            </div>
          </div>

          <h2>🔐 CALM Portal</h2>

          {/* Form */}
          <div className="form-input-container">
            <input
              className="form-input"
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="form-input-container">
            <input
              className="form-input"
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* ✅ Improved UX: Show/Hide password */}
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "HIDE" : "SHOW"}
            </button>
          </div>

          <button
            className="login-btn"
            onClick={handleLogin}
            disabled={loading} // ✅ PREVENT MULTIPLE CLICK
          >
            {loading ? (
              <>
                <div className="spinner"></div> Authenticating...
              </>
            ) : (
              "ACCESS"
            )}
          </button>

          <div className="form-footer">
            Secure Administrative Interface
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;